 import { readable,writable,derived } from 'svelte/store'
import { urlServeur } from '../components/conf.js'
/**
 * Stores initialiser par un fichier Json reçu par REST
*/

export const recettes = readable(null, function start(set) {
    //console.log("in strore....")
    fetch(urlServeur + "/api/immeubles/recettes")
        .then(function (response) {
            if (!response.ok) {
                throw new Error('unable to load recettes on recettesstore init');
            }
            return response.json();
        })
        .then(function (data) {
            const liste = data.payload;
            //console.log(liste)
            set(liste);
        });

    return function stop() {
        //console.log('RecettesStore Stopped');
    };
});



/**
 * Store pour le popup utilisé pour la rechercher
 */
export const term = writable({
    'titre': '',
    'type':''
});

/**
 * Filtre le store recette sur 2 champs
 */
export const filtered = derived([recettes, term], ([$recettes, $term]) => {
    let result = [];

    if ($term.type != '') {
        if ($term.type == 'all') {
            result = $recettes
        } else {
            result = $recettes.filter((item) => item.type.toLowerCase().includes($term.type.toLowerCase()));

        }
        $term.type = ""
        $term.titre = ""
    } else if ($term.titre != '') {
        result = $recettes.filter((item) => item.titre.toLowerCase().includes($term.titre.toLowerCase()));
        //
    } else {
        result = $recettes
    }
    return result
})

